module.exports = __webpack_public_path__ + "img/rule_btn.0fb2871c.png";